const setStatuses = (state, statuses) => {
  state.status = statuses
}

export default {
  setStatuses
}
